import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import {
  HeroSection,
  MeetingAnalysisSection,
  RAGKnowledgeSection,
  AgenticAISection,
  EnterpriseSection,
} from "@/components/landing";
import { PublicFooter } from "@/components/PublicFooter";
import { useAuthStore } from "@/store/authStore";
import { getPostAuthRoute } from "@/lib/routes";

const Index = () => {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isAuthChecked = useAuthStore((state) => state.isAuthChecked);

  useEffect(() => {
    if (!isAuthChecked || !isAuthenticated) return;
    navigate(getPostAuthRoute(window.location.hostname), { replace: true });
  }, [isAuthChecked, isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navigation />
      <main className="flex-1">
        <HeroSection />
        <MeetingAnalysisSection />
        <RAGKnowledgeSection />
        <AgenticAISection />
        <EnterpriseSection />
      </main>
      <PublicFooter />
    </div>
  );
};

export default Index;
